import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Form, message, Row, Space, Spin } from "antd";
import moment from "moment";
import Notification from "../../../../../../../components/common/notification/notification";
import { InputFields } from "../../../../../../../components/common";

import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../../redux/hooks";
import { getPhongBanAPI } from "../../../../../../../redux/reducer/employee";

import { employeeService } from "api";
import dayjs from "dayjs";
import { DataFormField } from "types/models/input-field-type";
import { FIELD_TYPE, FORMAT_TIME, tabKeys } from "types/enums";
import { RangePickerProps } from "antd/es/date-picker";
import { setActiveKey } from "redux/reducer/common";
import { formatDateToString } from "helper/common";
const {
  INPUT,
  DATE,
  DATE_DISABLE_NO_DAY,
  COMBO_BOX,
  AUTO_COMPLETE,
  CURRENCY,
  NUMBER,
  DATE_PRE,
  RADIO_VN,
  RADIO,
  CHECKBOX,
  RADIO_CUSTOM,
} = FIELD_TYPE;
const Tab2 = React.forwardRef((props: any, ref) => {
  const onChangeNV = (e) => {
    let totalCT =
      Number(form.getFieldValue("ctDong")) +
        Number(form.getFieldValue("veMayBay")) +
        Number(form.getFieldValue("chiPhiAnO")) +
        Number(form.getFieldValue("troCapHangThang")) +
        Number(form.getFieldValue("baoHiemDiLaiQuocTe")) +
        Number(form.getFieldValue("baoHiemYTeCaNhan")) +
        Number(form.getFieldValue("baoHiemSoSuatYTe")) +
        Number(form.getFieldValue("lePhiCapVisa")) ?? 0;
    let total = totalCT + Number(e);
    form.setFieldsValue({
      tongSoCPDT: total,
    });
  };
  const onChangeCT = (e) => {
    let totalNV =
      Number(form.getFieldValue("nvDong")) +
        Number(form.getFieldValue("veMayBay")) +
        Number(form.getFieldValue("chiPhiAnO")) +
        Number(form.getFieldValue("troCapHangThang")) +
        Number(form.getFieldValue("baoHiemDiLaiQuocTe")) +
        Number(form.getFieldValue("baoHiemYTeCaNhan")) +
        Number(form.getFieldValue("baoHiemSoSuatYTe")) +
        Number(form.getFieldValue("lePhiCapVisa")) ?? 0;
    let total = totalNV + Number(e);
    form.setFieldsValue({
      tongSoCPDT: total,
    });
  };
  const onChangeVe = (e) => {
    let totalVe =
      Number(form.getFieldValue("nvDong")) +
        Number(form.getFieldValue("ctDong")) +
        Number(form.getFieldValue("chiPhiAnO")) +
        Number(form.getFieldValue("troCapHangThang")) +
        Number(form.getFieldValue("baoHiemDiLaiQuocTe")) +
        Number(form.getFieldValue("baoHiemYTeCaNhan")) +
        Number(form.getFieldValue("baoHiemSoSuatYTe")) +
        Number(form.getFieldValue("lePhiCapVisa")) ?? 0;
    let total = totalVe + Number(e);
    form.setFieldsValue({
      tongSoCPDT: total,
    });
  };
  const onChangeChiPhi = (e) => {
    let totalCP =
      Number(form.getFieldValue("nvDong")) +
        Number(form.getFieldValue("ctDong")) +
        Number(form.getFieldValue("veMayBay")) +
        Number(form.getFieldValue("troCapHangThang")) +
        Number(form.getFieldValue("baoHiemDiLaiQuocTe")) +
        Number(form.getFieldValue("baoHiemYTeCaNhan")) +
        Number(form.getFieldValue("baoHiemSoSuatYTe")) +
        Number(form.getFieldValue("lePhiCapVisa")) ?? 0;
    let total = totalCP + Number(e);
    form.setFieldsValue({
      tongSoCPDT: total,
    });
  };
  const onChangeTroCap = (e) => {
    let totalTC =
      Number(form.getFieldValue("nvDong")) +
        Number(form.getFieldValue("ctDong")) +
        Number(form.getFieldValue("veMayBay")) +
        Number(form.getFieldValue("chiPhiAnO")) +
        Number(form.getFieldValue("baoHiemDiLaiQuocTe")) +
        Number(form.getFieldValue("baoHiemYTeCaNhan")) +
        Number(form.getFieldValue("baoHiemSoSuatYTe")) +
        Number(form.getFieldValue("lePhiCapVisa")) ?? 0;
    let total = totalTC + Number(e);
    form.setFieldsValue({
      tongSoCPDT: total,
    });
  };
  const onChangeBHQuocTe = (e) => {
    let totalBHQT =
      Number(form.getFieldValue("nvDong")) +
        Number(form.getFieldValue("ctDong")) +
        Number(form.getFieldValue("veMayBay")) +
        Number(form.getFieldValue("chiPhiAnO")) +
        Number(form.getFieldValue("troCapHangThang")) +
        Number(form.getFieldValue("baoHiemYTeCaNhan")) +
        Number(form.getFieldValue("baoHiemSoSuatYTe")) +
        Number(form.getFieldValue("lePhiCapVisa")) ?? 0;
    let total = totalBHQT + Number(e);
    form.setFieldsValue({
      tongSoCPDT: total,
    });
  };
  const onChangeBHCaNhan = (e) => {
    let totalBHCN =
      Number(form.getFieldValue("nvDong")) +
        Number(form.getFieldValue("ctDong")) +
        Number(form.getFieldValue("veMayBay")) +
        Number(form.getFieldValue("chiPhiAnO")) +
        Number(form.getFieldValue("troCapHangThang")) +
        Number(form.getFieldValue("baoHiemDiLaiQuocTe")) +
        Number(form.getFieldValue("baoHiemSoSuatYTe")) +
        Number(form.getFieldValue("lePhiCapVisa")) ?? 0;
    let total = totalBHCN + Number(e);
    form.setFieldsValue({
      tongSoCPDT: total,
    });
  };
  const onChangeBHSS = (e) => {
    let totalBHSS =
      Number(form.getFieldValue("nvDong")) +
        Number(form.getFieldValue("ctDong")) +
        Number(form.getFieldValue("veMayBay")) +
        Number(form.getFieldValue("chiPhiAnO")) +
        Number(form.getFieldValue("troCapHangThang")) +
        Number(form.getFieldValue("baoHiemDiLaiQuocTe")) +
        Number(form.getFieldValue("baoHiemYTeCaNhan")) +
        Number(form.getFieldValue("lePhiCapVisa")) ?? 0;
    let total = totalBHSS + Number(e);
    form.setFieldsValue({
      tongSoCPDT: total,
    });
  };
  const onChangeLePhi = (e) => {
    let totalLP =
      Number(form.getFieldValue("nvDong")) +
        Number(form.getFieldValue("ctDong")) +
        Number(form.getFieldValue("veMayBay")) +
        Number(form.getFieldValue("chiPhiAnO")) +
        Number(form.getFieldValue("troCapHangThang")) +
        Number(form.getFieldValue("baoHiemDiLaiQuocTe")) +
        Number(form.getFieldValue("baoHiemYTeCaNhan")) +
        Number(form.getFieldValue("baoHiemSoSuatYTe")) ?? 0;
    let total = totalLP + Number(e);
    form.setFieldsValue({
      tongSoCPDT: total,
    });
  };

  const onChange = async (e) => {
    try {
      const array = form.getFieldValue("daoTaoLe");
      // console.log("đào tạo lẻ", array);
      if (array.includes(1)) {
        // Check if "1" is present in the array
        const updatedFieldsCV = fieldInfo.map((field) => {
          if (
            field.name === "veMayBay" ||
            field.name === "chiPhiAnO" ||
            field.name === "troCapHangThang" ||
            field.name === "baoHiemDiLaiQuocTe" ||
            field.name === "baoHiemYTeCaNhan" ||
            field.name === "baoHiemSoSuatYTe" ||
            field.name === "lePhiCapVisa" ||
            field.name === "donViDaoTao" ||
            field.name === "hinhThucDaoTao" ||
            field.name === "maDaoTao" ||
            field.name === "ngayLap" ||
            field.name === "quyetDinh" ||
            field.name === "tenKhoaDaoTao" ||
            field.name === "mucDich" ||
            field.name === "noiDaoTao" ||
            field.name === "daoTaoTuNgayDto" ||
            field.name === "daoTaoDenNgayDto" ||
            field.name === "soNgay" ||
            field.name === "chiPhiCho1Tv" ||
            field.name === "nvDong" ||
            field.name === "ctDong" ||
            //  field.name === "tongSoCPDT" ||
            field.name === "noiDung" ||
            field.name === "moTa" ||
            field.name === "soTietDaoTao" ||
            field.name === "daoTaoLienTuc" ||
            field.name === "daoTaoLe"
          ) {
            return {
              ...field,
              disable: false,
            };
          } else {
            return {
              ...field,
              disable: true,
            };
          }
        });
        setFieldInfo(updatedFieldsCV);
      } else {
        const updatedFieldsCV = fieldInfo.map((field) => {
          if (
            field.name === "veMayBay" ||
            field.name === "chiPhiAnO" ||
            field.name === "troCapHangThang" ||
            field.name === "baoHiemDiLaiQuocTe" ||
            field.name === "baoHiemYTeCaNhan" ||
            field.name === "baoHiemSoSuatYTe" ||
            field.name === "tongSoCPDT" ||
            field.name === "lePhiCapVisa"
          ) {
            return {
              ...field,
              disable: true,
            };
          } else {
            return {
              ...field,
              disable: false,
            };
          }
        });
        setFieldInfo(updatedFieldsCV);
      }
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi");
    }
  };

  const dataFields: any[] = [
    {
      type: INPUT,
      label: "Đơn vị đào tạo",
      name: "donViDaoTao",
      disable: false,
    },
    {
      type: INPUT,
      name: "hinhThucDaoTao",
      label: "Hinh thức đào tạo",
      disable: false,
    },
    {
      type: INPUT,
      name: "maDaoTao",
      label: "Mã đào tạo",
      disable: false,
    },
    {
      type: DATE,

      name: "ngayLap",
      label: "Ngày lập",
      disable: false,
      disableDate: false,
    },
    {
      type: INPUT,
      name: "quyetDinh",
      label: "Quyết định",
      disable: false,
    },
    {
      type: INPUT,
      name: "tenKhoaDaoTao",
      label: "Tên khóa ĐT",
      disable: false,
    },
    {
      type: INPUT,
      name: "soTietDaoTao",
      label: "Số tiết đào tạo",
      disable: false,
    },
    {
      type: INPUT,
      name: "mucDich",
      label: "Mục đích",
      disable: false,
    },
    {
      type: INPUT,
      name: "noiDaoTao",
      label: "Nơi ĐT",
      disable: false,
    },
    {
      type: DATE_DISABLE_NO_DAY,

      name: "daoTaoTuNgayDto",
      label: "ĐT từ ngày",
      disable: false,
      disableDate: false,
      optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
    },
    {
      type: DATE_DISABLE_NO_DAY,

      name: "daoTaoDenNgayDto",
      label: "ĐT đến ngày",
      disable: false,
      disableDate: false,
      optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
    },
    {
      type: INPUT,
      name: "soNgay",
      label: "Số ngày",
      disable: false,
    },
    // {
    //   type: CURRENCY,
    //   name: "chiPhiCho1Tv",
    //   label: "Chi phí cho 1 thành viên",
    //   disable: false,
    // },
    {
      type: CURRENCY,
      name: "nvDong",
      label: "NV đóng",
      disable: false,
      onChange: onChangeNV,
    },
    {
      type: CURRENCY,
      name: "ctDong",
      label: "CT đóng",
      disable: false,
      onChange: onChangeCT,
    },
    {
      type: CURRENCY,
      name: "veMayBay",
      label: "Vé máy bay",
      disable: true,
      onChange: onChangeVe,
    },
    {
      type: CURRENCY,
      name: "chiPhiAnO",
      label: "Chi phí ăn ở",
      disable: true,
      onChange: onChangeChiPhi,
    },
    {
      type: CURRENCY,
      name: "troCapHangThang",
      label: "Trợ cấp hàng tháng",
      disable: true,
      onChange: onChangeTroCap,
    },
    {
      type: CURRENCY,
      name: "baoHiemDiLaiQuocTe",
      label: "Bảo hiểm đi lại quốc tế",
      disable: true,
      onChange: onChangeBHQuocTe,
    },
    {
      type: CURRENCY,
      name: "baoHiemYTeCaNhan",
      label: "Bảo hiểm cá nhân",
      disable: true,
      onChange: onChangeBHCaNhan,
    },
    {
      type: CURRENCY,
      name: "baoHiemSoSuatYTe",
      label: "Bảo hiểm sơ suất y tế",
      disable: true,
      onChange: onChangeBHSS,
    },
    {
      type: CURRENCY,
      name: "lePhiCapVisa",
      label: "Lệ phí cấp visa",
      disable: true,
      onChange: onChangeLePhi,
    },
    {
      type: CURRENCY,
      name: "tongSoCPDT",
      label: "Tổng chi phí",
      disable: true,
    },
    {
      type: INPUT,
      name: "noiDung",
      label: "Nội dung",
      disable: false,
    },
    {
      type: INPUT,
      name: "moTa",
      label: "Mô tả",
      disable: false,
    },
    {
      name: "daoTaoLienTuc",
      type: CHECKBOX,
      label: "",
      checkbox: [
        {
          label: "Đào tạo liên tục",
          value: 1,
          span: 32,
        },
      ],
    },
    {
      name: "daoTaoLe",
      type: CHECKBOX,
      label: "",
      onChange: onChange,
      checkbox: [
        {
          label: "Đào tạo lẻ",
          value: 1,
          span: 32,
        },
      ],
    },
  ];
  const { data, closeModal, type, getListApi, setCurrentPage } = props;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const employees = useAppSelector((state) => state.employeesReducer);
  const modalRef = useRef<any>();
  const dispatch = useAppDispatch();
  const [fieldInfo, setFieldInfo] = useState(dataFields);
  useEffect(() => {
    const disabledDateStart: RangePickerProps["disabledDate"] = (
      currentDate
    ) => {
      const endDay = form.getFieldValue("daoTaoDenNgayDto");
      if (endDay) {
        return currentDate > endDay;
      }
    };
    const disabledDateEnd: RangePickerProps["disabledDate"] = (currentDate) => {
      const start = form.getFieldValue("daoTaoTuNgayDto");
      if (start) {
        return currentDate < start;
      }
    };
    dataFields.find((e) => e.name == "daoTaoTuNgayDto").disabledDate =
      disabledDateStart;
    dataFields.find((e) => e.name == "daoTaoDenNgayDto").disabledDate =
      disabledDateEnd;
    setFieldInfo([...dataFields]);
  }, []);
  useEffect(() => {
    if (type == "Thêm") {
      form.resetFields();
    } else {
      form.setFieldsValue(data);
      try {
        const array = form.getFieldValue("daoTaoLe");
        // console.log("đào tạo lẻ", array);
        if (array.includes(1)) {
          // Check if "1" is present in the array
          const updatedFieldsCV = fieldInfo.map((field) => {
            if (
              field.name === "veMayBay" ||
              field.name === "chiPhiAnO" ||
              field.name === "troCapHangThang" ||
              field.name === "baoHiemDiLaiQuocTe" ||
              field.name === "baoHiemYTeCaNhan" ||
              field.name === "baoHiemSoSuatYTe" ||
              field.name === "lePhiCapVisa" ||
              field.name === "donViDaoTao" ||
              field.name === "hinhThucDaoTao" ||
              field.name === "maDaoTao" ||
              field.name === "ngayLap" ||
              field.name === "quyetDinh" ||
              field.name === "tenKhoaDaoTao" ||
              field.name === "mucDich" ||
              field.name === "noiDaoTao" ||
              field.name === "daoTaoTuNgayDto" ||
              field.name === "daoTaoDenNgayDto" ||
              field.name === "soNgay" ||
              field.name === "chiPhiCho1Tv" ||
              field.name === "nvDong" ||
              field.name === "ctDong" ||
              //  field.name === "tongSoCPDT" ||
              field.name === "noiDung" ||
              field.name === "moTa" ||
              field.name === "soTietDaoTao" ||
              field.name === "daoTaoLienTuc" ||
              field.name === "daoTaoLe"
            ) {
              return {
                ...field,
                disable: false,
              };
            } else {
              return {
                ...field,
                disable: true,
              };
            }
          });
          setFieldInfo(updatedFieldsCV);
        } else {
          const updatedFieldsCV = fieldInfo.map((field) => {
            if (
              field.name === "veMayBay" ||
              field.name === "chiPhiAnO" ||
              field.name === "troCapHangThang" ||
              field.name === "baoHiemDiLaiQuocTe" ||
              field.name === "baoHiemYTeCaNhan" ||
              field.name === "baoHiemSoSuatYTe" ||
              field.name === "tongSoCPDT" ||
              field.name === "lePhiCapVisa"
            ) {
              return {
                ...field,
                disable: true,
              };
            } else {
              return {
                ...field,
                disable: false,
              };
            }
          });
          setFieldInfo(updatedFieldsCV);
        }
      } catch (error) {
        Notification("error", "Đã xảy ra lỗi");
      }
    }
  }, [data]);
  useEffect(() => {
    form.setFieldsValue({
      ...data,
      ngayLap: data?.ngayLap ? dayjs(data.ngayLap) : null,
      daoTaoTuNgayDto: data?.daoTaoTuNgay ? dayjs(data.daoTaoTuNgay) : null,
      daoTaoDenNgayDto: data?.daoTaoDenNgay ? dayjs(data.daoTaoDenNgay) : null,
    });
  }, [data]);
  const addApi = async () => {
    setLoading(true);
    const value = form.getFieldsValue();
    try {
      const params = {
        ...value,
        daoTaoTuNgayDto: formatDateToString(
          value.daoTaoTuNgayDto,
          FORMAT_TIME.dayFull
        ),
        daoTaoDenNgayDto: formatDateToString(
          value.daoTaoDenNgayDto,
          FORMAT_TIME.dayFull
        ),
      };
      await employeeService.updateTraning(params).then((res) => {
        Notification("success", "Đã thêm mới thành công ");
        // dispatch(setActiveKey(tabKeys.TRAINING.LIST_TRAINNING));
      });
      setLoading(false);
      closeModal();
      await getListApi({});
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi khi thêm mới  khóa đào tạo");
    }
  };
  const editApi = async () => {
    setLoading(true);
    const value = form.getFieldsValue();
    try {
      const params = {
        ...value,
        id: data.id,
        daoTaoTuNgayDto: formatDateToString(
          value.daoTaoTuNgayDto,
          FORMAT_TIME.dayFull
        ),
        daoTaoDenNgayDto: formatDateToString(
          value.daoTaoDenNgayDto,
          FORMAT_TIME.dayFull
        ),
      };
      const res = await employeeService.updateTraning(params).then((res) => {
        Notification("success", "Đã chỉnh sửa thành công thành công ");
        // dispatch(setActiveKey(tabKeys.TRAINING.LIST_TRAINNING));
      });
      setLoading(false);
      closeModal();
      await getListApi({});
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi khi sửa thông tin khóa đào tạo");
    }
  };

  const onFinish = (values) => {
    if (type == "Thêm") {
      addApi();
    } else {
      editApi();
    }
  };
  const handleModalClose = () => {
    dispatch(setActiveKey(tabKeys.TRAINING.LIST_TRAINNING));
    closeModal();
    // Explicitly set activeTab to LIST_TRAINING after closing the modal
  };
  return (
    <div style={{ marginTop: 10 }}>
      <Spin spinning={loading}>
        <Form form={form} onFinish={onFinish}>
          <Space direction="vertical" style={{ width: "100%" }}>
            <Row gutter={[16, 8]}>
              <InputFields data={fieldInfo}></InputFields>
            </Row>
            <Row justify="end" style={{ marginTop: 12 }}>
              <Col>
                <Space>
                  <Button
                    onClick={handleModalClose}
                    style={{
                      backgroundColor: "red",
                      borderColor: "red",
                      color: "white",
                    }}
                  >
                    Hủy bỏ
                  </Button>
                  <Button htmlType="submit" type="primary">
                    Lưu lại
                  </Button>
                </Space>{" "}
              </Col>
            </Row>
          </Space>
        </Form>
      </Spin>
    </div>
  );
});
export default Tab2;
